import React from 'react';
import './AvisoPrivacidad.css';

const AvisoPrivacidad = () => {
  return (
    <div className="aviso-container">
      <div className="aviso-contenido">
        <h1>AVISO DE PRIVACIDAD</h1>

        <p>
          De conformidad con lo previsto en la nueva Ley Federal de Protección de Datos Personales en
          Posesión de los Particulares (la “Ley”) y su reglamento (el “Reglamento”), con la finalidad de
          proteger y establecer su política de recolección de datos personales en posesión de la sociedad
          Moti Digital, S. de R.L. de C.V. (el “Responsable” y/o la “Sociedad”), con domicilio en Calle 1,
          número 1375, interior 6, colonia Zona Industrial, Guadalajara, Jalisco, código postal 44940,
          México, y la página de internet https://www.motidigital.com/ se establece el presente aviso de
          privacidad (el “Aviso de Privacidad”) de acuerdo con los siguientes términos y condiciones:
        </p>

        <p>
          El presente Aviso de Privacidad tiene por objeto la protección de cualquier información
          concerniente a la o las personas físicas identificadas o identificables, de clientes,
          proveedores, y demás terceros que guarden una relación con la Sociedad (el “Titular”),
          regulando el uso y la protección de los Datos Personales del Titular, mediante su tratamiento
          legítimo, controlado e informado, a efecto de garantizar su privacidad, así como el derecho del
          Titular a la autodeterminación informativa, de conformidad con el artículo 14 de la Ley.
        </p>

        <h2>¿Para qué fines utilizaremos sus datos personales?</h2>

        <p>
          Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades
          que son necesarias para el servicio que solicita:
        </p>

        <ul>
          <li>Atender solicitudes de atención al Titular y procesar pagos relacionados con dicha solicitud;</li>
          <li>Identificar, ubicar, contactar y enviar información al Titular;</li>
          <li>Integrar su expediente como cliente;</li>
          <li>Llevar a cabo la transmisión de los derechos o productos relacionados con los mismos;</li>
          <li>El conocimiento del mercado y el desempeño de la empresa dentro de éste;</li>
          <li>Seguimiento a compras y/o servicios;</li>
          <li>Cobros;</li>
          <li>Desarrollo de estudios para determinar la satisfacción del Titular;</li>
          <li>
            La integración de base de datos y expedientes personales de los clientes, o potenciales
            clientes para fines internos de administración y estadísticos;
          </li>
        </ul>

        <h2>¿Qué datos personales utilizaremos para estos fines?</h2>

        <p>
          Para llevar a cabo las finalidades descritas en el presente Aviso de Privacidad, utilizaremos
          los siguientes datos personales de identificación (los “Datos Personales”):
        </p>

        <ul>
          <li>Nombre completo / denominación social;</li>
          <li>Dirección de correo electrónico;</li>
          <li>Dirección de facturación;</li>
          <li>Dirección operativa;</li>
          <li>Información de pago y depósito;</li>
          <li>Número telefónico;</li>
          <li>Dirección IP;</li>
          <li>Geolocalización;</li>
          <li>Historial de servicios;</li>
          <li>Acta constitutiva y poder, en su caso;</li>
          <li>Registro Federal de Contribuyentes; e</li>
          <li>Identificación oficial del Titular o su representante legal, en su caso.</li>
        </ul>

        <h2>Medidas de seguridad para garantizar la protección de los Datos Personales.</h2>

        <p>
          La Sociedad, como responsable de posesión de Datos Personales del Titular, está obligada a
          cumplir con los principios de licitud, consentimiento, información, calidad, finalidad,
          lealtad, proporcionalidad y responsabilidad previstos por la Ley y su Reglamento. Por tal
          motivo, con fundamento en los artículos 5, 18 y 20 de la Ley, la Sociedad se compromete a
          guardar estricta confidencialidad de los Datos Personales del Titular, así como a mantener las
          medidas de seguridad administrativas, técnicas y físicas que permitan protegerlos contra
          cualquier daño, pérdida, alteración, acceso, uso, divulgación o tratamiento no autorizado.
        </p>

        <h2>¿Cómo puede acceder, rectificar o cancelar sus datos personales, u oponerse a su uso?</h2>

        <p>
          La temporalidad del manejo de los Datos Personales del Titular será indefinida, misma que
          iniciará a partir de la fecha en que el Titular los proporcionen al Responsable pudiendo
          oponerse al manejo los Datos personales de acuerdo con sus derechos de acceso, rectificación,
          cancelación u oposición (“ARCO”) de conformidad con los artículos 27, 28, 29 y 34 de la Ley.
        </p>

        <p>
          Asimismo, en términos de lo establecido por los artículos 22, 28, 29 y 34 de la Ley, el Titular
          de los Datos Personales tiene derecho, en cualquier momento, a ejercer sus derechos ARCO con
          relación al tratamiento de sus Datos Personales en posesión de la Sociedad, mediante una
          solicitud vía correo electrónico a la dirección de correo electrónico
          nominas@motidigital.com, en atención a Susana Jauregui, o mediante una notificación por escrito
          al domicilio de la Sociedad.
        </p>

        <p>
          De acuerdo con el artículo 28 de la Ley, la solicitud de acceso, rectificación, cancelación u
          oposición de los Datos Personales deberá contener y acompañar lo siguiente:
        </p>

        <ol>
          <li>Nombre y domicilio del Titular u otro medio para comunicar la respuesta a la solicitud;</li>
          <li>
            Los documentos que acrediten la identidad del Titular o, en su caso, la representación legal
            de la persona que realiza la solicitud;
          </li>
          <li>
            La descripción clara y precisa de los Datos Personales respecto de los que busca ejercer
            alguno de los derechos antes mencionados;
          </li>
          <li>
            La descripción del derecho antes mencionado que se pretende ejercer, o la solicitud que
            desea hacer respecto a sus Datos Personales en posesión del Responsable; y
          </li>
          <li>
            Cualquier otro elemento o documento que facilite la localización de sus Datos Personales.
          </li>
        </ol>

        <p>
          En caso de solicitar la rectificación de Datos Personales, adicionalmente el Titular o su
          representante, deberá indicar las modificaciones a realizarse y aportar la documentación que
          sustente su petición.
        </p>

        <p>
          De conformidad con el artículo 31 de la Ley, el Responsable comunicará al Titular, en un plazo
          máximo de veinte días hábiles, contados desde la fecha en que se recibió la solicitud de
          acceso, rectificación, cancelación u oposición, la determinación adoptada, a efecto de que, si
          resulta procedente, se haga efectiva la misma dentro de los quince días siguientes a la fecha
          en que se comunica la respuesta. Sin embargo, dicho plazo podrá ampliarse una sola vez por un
          periodo igual, cuando así lo justifiquen las circunstancias del caso.
        </p>

        <h2>Transferencia de datos personales:</h2>

        <p>
          Sus datos personales podrán ser transferidos a terceros, para el cumplimiento de las
          obligaciones y servicios que la Sociedad le ofrece en los casos necesarios, por lo que, en
          este acto otorga su consentimiento a la Sociedad para que ésta esté facultada para transferir
          sus datos personales.
        </p>

        <h2>Revocación de consentimiento para el uso de datos personales:</h2>

        <p>
          Usted puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento
          de sus datos personales. Sin embargo, es importante que tenga en cuenta que no en todos los
          casos podremos atender su solicitud o concluir el uso de forma inmediata, ya que es posible
          que por alguna obligación legal requiramos seguir tratando sus Datos Personales. Asimismo,
          usted deberá considerar que, para ciertos fines, la revocación de su consentimiento
          implicará que no le podamos seguir prestando el servicio que nos solicitó, o la conclusión de
          su relación con nosotros.
        </p>

        <h2>El uso de tecnologías de rastreo en nuestro portal de internet.</h2>

        <p>
          Le informamos que en nuestra página de internet utilizamos cookies, web beacons u otras
          tecnologías, a través de las cuales es posible monitorear su comportamiento como usuario de
          internet, así como brindarle un mejor servicio y experiencia al navegar en nuestra página.
          Los datos personales que recabamos a través de estas tecnologías, los utilizaremos para los
          siguientes fines:
        </p>

        <p>
          El portal web https://www.motidigital.com/ requiere de la habilitación de cookies en su
          navegador web para la correcta funcionalidad de este sitio. Cookies son archivos de texto que
          se descargan automáticamente y se almacenan en la computadora del usuario mientras se navega
          en un sitio web en particular, permitiendo así al servidor de Internet recordar cierta
          información acerca del usuario, incluyendo sus preferencias al ver páginas en este servidor,
          así como los nombres de usuario y contraseñas. Mientras que, web beacons son imágenes colocadas
          en un sitio web o correo electrónico, las cuales pueden ser utilizadas para monitorear el
          comportamiento del usuario, como puede ser el almacenamiento de información referente a la
          dirección IP del usuario, tiempo de interacción en un sitio web en particular y el navegador
          web que se utilizó, entre otras cosas.
        </p>

        <p>
          Los datos personales que obtenemos a través de estas tecnologías de rastreo son los siguientes:
        </p>

        <ul>
          <li>Región en la que se encuentra el usuario;</li>
          <li>Tipo de navegador del usuario;</li>
          <li>Tipo de sistema operativo del usuario;</li>
          <li>Páginas web visitadas por un usuario;</li>
          <li>Búsquedas realizadas por un usuario; y,</li>
          <li>La dirección IP.</li>
        </ul>

        <p>
          Estas tecnologías podrán deshabilitarse siguiendo los siguientes pasos: Desactivar el uso de
          cookies puede inhabilitar ciertas funciones del portal https://www.motidigital.com/ o no
          permitir que se muestren en la forma que originalmente fueron diseñados. En caso de que se
          prefiera eliminar la información mandada por las cookies de https://www.motidigital.com/,
          puede eliminar estos archivos al final de cada sesión dentro de su navegador. La información
          de interés sobre cómo hacer esto puede ser consultada en los sitios principales de cada
          navegador.
        </p>

        <h2>¿Cómo puede conocer los cambios en este aviso de privacidad?</h2>

        <p>
          El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones
          derivadas de nuevos requerimientos legales; de nuestras propias necesidades por los productos
          o servicios que ofrecemos; de nuestras prácticas de privacidad; de cambios en nuestro modelo
          de negocio, o por otras causas.
        </p>

        <p>
          El Responsable se reserva el derecho a realizar cualquier modificación o actualización del
          Aviso de Privacidad actual, con la finalidad de cumplir con la nueva legislación, políticas
          internas o nuevos requerimientos para la promoción y ofrecimiento de nueva información y
          productos.
        </p>

        <p>
          Cualquier modificación al Aviso de Privacidad actual, puede ser consultado en
          https://www.motidigital.com/.
        </p>

        <h2>Su consentimiento para el tratamiento de sus datos personales</h2>

        <p>
          Consiento que mis datos personales sean tratados de conformidad con los términos y condiciones
          informados en el presente Aviso de Privacidad.
        </p>

        <p><strong>Última actualización:</strong> 15 de septiembre de 2025.</p>
      </div>
    </div>
  );
};

export default AvisoPrivacidad;
